import { createFileRoute } from '@tanstack/react-router';

import { WeeklyListPage } from '@/features/insights/weekly-pages';

export const Route = createFileRoute('/_app/projects/$projectId/insights/weekly/')({
  component: WeeklyRoute,
});

function WeeklyRoute() {
  const { projectId } = Route.useParams();
  return <WeeklyListPage projectId={projectId} />;
}
